import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 1a.5.5 0 0 1 .5.5V12h11.5a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5m11.354 3.146a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0L6 6.707 3.854 8.854a.5.5 0 1 1-.708-.708l2.5-2.5a.5.5 0 0 1 .708 0L8.5 7.793l3.646-3.647a.5.5 0 0 1 .708 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }